'use strict';

angular.module('cvsApp').controller('MakePaymentCtrl', ["$scope", "$state", "userSession", "webAnalytics", "loggerService", "loggerServiceHelper",
  function ($scope, $state, UserSession, webAnalytics, loggerService, loggerServiceHelper) {
    var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED) + loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.PaymentType));
    log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.START));

    cvsUtility.genralPostMessage("SCROLL_TO", {
      "scroll": true
    });
    setTimeout(function () {
      if (!UserSession.registered) {
        var utagObj = {
          "tsrc": cvsUtility.queryMap.source
        };

        /**
         * sankar 11/22/2016 - ITPR017031 - guest make payment
         * Added WTS pagename,platform tag
         */
        if (self == top) {
          utagObj = {
            pagename: 'PAYMENT-guestMakePayment'
          };
        }
        webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "guestMakePayment");
      } else {
        /**
         * 04/09/2020 GST-164 Yogi - Make a Payment
          Added WTS pagename
         */
        var utagObj = {
          "tsrc": cvsUtility.queryMap.source,
          scenario_name: 'reg:OLP',
          scenario_step: 'payment type'
        };
        utagObj.page_name = 'srx: make a payment';
        utagObj.adobe_page_name = 'cvssp' + '|' + cvsUtility.getPlatform() + '|' + utagObj.page_name;
        utagObj.page_category = 'payments';
        utagObj.event_name = 'event23';
        webAnalytics.webTrendsUtag("OBJ", utagObj, undefined);

      }
    }, 3000);
    $scope.content = wcmContent;
    $scope.paymentAmount = {
      valid: true,
      moreThanThird: true,
      lessThanBalance: true
    };

    if (!UserSession.paymentAmount) {
      UserSession.paymentAmount = "";
    }

    //cvsUtility.resetSessoinTimeOut();

    $scope.oneThirdError = function (amt) {
      return amt < UserSession.accountData.currentBalance / 3;
    };

    $scope.exBalanceError = function (amt) {
      return amt > UserSession.accountData.currentBalance;
    };

    $scope.validatePaymentAmount = function (amt) {
      //  If it isn't a partial payment, validation is unnecessary
      $scope.paymentAmount.valid = true;
      $scope.paymentAmount.moreThanThird = true;
      $scope.paymentAmount.lessThanBalance = true;
      $scope.paymentAmount.enterAmount = true;
      $scope.paymentAmount.digitError = false;
      $scope.paymentAmount.invalid = false;
      if (UserSession.paymentType !== 'partial') {
        $scope.paymentAmount.valid = true;
      } else {
        if (!amt) {
          if (amt !== undefined && isNaN(amt)) {
            $scope.paymentAmount.valid = false;
            $scope.paymentAmount.invalid = true;
            log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("partialAmountValidation") + loggerServiceHelper.setDescription("Payment amount input field Error :Please enter a valid amount."));
          } else {
            $scope.paymentAmount.enterAmount = false;
            $scope.paymentAmount.valid = false;
            log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("partialAmountValidation") + loggerServiceHelper.setDescription("Payment amount input field Error : " + $scope.content.generalContent.specialty_make_payment_enter_balance));
          }
          /*Scroll to top*/
          cvsUtility.genralPostMessage("SCROLL_TO", {
            "scroll": true
          });
          return;
        } else {
          if (!cvsUtility.maxDecimalsDigit(2, "" + amt) || !cvsUtility.makeMaxDigits(8, amt)) {
            $scope.paymentAmount.digitError = true;
            /*Scroll to top*/
            log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("partialAmountValidation") + loggerServiceHelper.setDescription("Payment amount input field Error : " + $scope.content.generalContent.specialty_make_payment_digit_error));
            cvsUtility.genralPostMessage("SCROLL_TO", {
              "scroll": true
            });
            return false;
          }
        }
        log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("continueBtnClicked") + loggerServiceHelper.setFlowType("partial"));
      }
      if ($scope.oneThirdError(amt)) {
        $scope.paymentAmount.moreThanThird = false;
        $scope.paymentAmount.valid = false;
      }
      if ($scope.exBalanceError(amt)) {
        $scope.paymentAmount.lessThanBalance = false;
        $scope.paymentAmount.valid = false;
      }
      cvsUtility.genralPostMessage("SCROLL_TO", {
        "scroll": true
      });
      return $scope.paymentAmount.valid;

    };

    $scope.submitPaymentForm = function () {
      localStorage.clear();
      Object.keys(UserSession.persit).forEach(function (key) {
        delete UserSession.persit[key];
      });
      var _valid = $scope.validatePaymentAmount(UserSession.paymentAmount);
      if (UserSession.paymentType === 'partial' && !_valid) {
        $scope.paymentAmount.valid = false;
      } else {
        if (UserSession.paymentType !== 'partial') {
          log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("continueBtnClicked") + loggerServiceHelper.setFlowType("full"));
          UserSession.paymentAmount = UserSession.accountData.currentBalance;
        }
        if (UserSession.paymentType === "auto") {
          log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("continueBtnClicked") + loggerServiceHelper.setFlowType("auto"));
        }
        log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setDescription("Continue button clicked to navigate from make a payment page"));
        $state.go("payment-methods");
        setTimeout(function () {
          if (UserSession.registered) {
            var utagObj = {
              scenario_step: UserSession.paymentType === "auto" ? "Recurring AutoPay" : "1-time pay method",
              // paymenttype: UserSession.paymentType,
              "tsrc": cvsUtility.queryMap.source
            };
            webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "paymentMethod");
          } else {
            var paymethod;
            if (UserSession.paymentType == 'full') {
              paymethod = 'Full Payment';
            } else if (UserSession.paymentType == 'partial') {
              paymethod = 'Partial Payment';
            } else if (UserSession.paymentType == 'auto') {
              paymethod = 'Recurring Payment';
            }
            var utagObj = {
              // paymenttype: paymethod,
              "tsrc": cvsUtility.queryMap.source
            };
            webAnalytics.webTrendsUtag("OBJ", utagObj, undefined, "guestPaymentMethod");
          }
        }, 3000);

      }

    };
    log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END) + loggerServiceHelper.setDescription("Make payment page load completed"));
  }
]);